import actions from './actions';

const initState = {
    documents:    [],
    loading:    false,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_SUPPORT_DOCUMENTS:
            return {
                ...state,
                loading: true,
            };
        case actions.FETCH_SUPPORT_DOCUMENTS_SUCCESS:
            return {
                ...state,
                documents: action.docs,
                loading: false,
            };
        case actions.FETCH_SUPPORT_DOCUMENTS_ERROR:
            return {
                ...state,
                documents: [],
                loading: false,
            }
        default:
            return state;
    }
}
